import { render, staticRenderFns } from "./PixResumeForm.vue?vue&type=template&id=61b0298a&scoped=true"
import script from "./PixResumeForm.vue?vue&type=script&lang=js"
export * from "./PixResumeForm.vue?vue&type=script&lang=js"
import style0 from "./PixResumeForm.vue?vue&type=style&index=0&id=61b0298a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0298a",
  null
  
)

export default component.exports